var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseSmallV2 = function SvgCloseSmallV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 10.73 7.4 6.5l4.3-4.23a.94.94 0 0 0 0-1.376.978.978 0 0 0-1.4 0L6 5.124 1.7.893a.978.978 0 0 0-1.4 0 .94.94 0 0 0 0 1.377L4.6 6.5.3 10.73a.94.94 0 0 0 0 1.376c.2.197.5.295.7.295.2 0 .5-.098.7-.295L6 7.876l4.3 4.23c.2.197.5.295.7.295.2 0 .5-.098.7-.295a.94.94 0 0 0 0-1.377Z",
    fill: "#262727"
  })));
};
export default SvgCloseSmallV2;